import { render, staticRenderFns } from "./IdEditor.vue?vue&type=template&id=6d9f64c0&scoped=true"
import script from "./IdEditor.vue?vue&type=script&lang=js"
export * from "./IdEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9f64c0",
  null
  
)

export default component.exports